<template>
  <section id="section-trending-stock" class="section-trending">
    <h2>Trending Stocks</h2>
    <div class="fade"></div>
    <swiper v-if="getTrendingStockList.length" :options="swiperOption" class="trending-list">
      <swiper-slide
        class="item"
        v-for="(stock, index) in getTrendingStockList"
        :key="stock.security_id"
      >
        <a
          href="javascript:;"
          @click="clickList(stock)"
          data-action="open_stock"
          data-listname="search_trending"
          :data-fundname="stock.security_name"
          style="text-decoration:none"
        >
          <div class="trending-data">
            <h4>{{stock.security_name}}</h4>
            <time>
              <i class="fal fa-clock"></i>
              {{stock.data_date | dateFilter}}
            </time>
            <div
              class="percent"
              v-bind:class="{ plus: stock.return_1d > 0, minus: stock.return_1d < 0 }"
            >{{stock.return_1d | roundHalfUp}}%</div>
            <div class="price">{{stock.close | roundHalfUp}} ฿</div>
            <label class="order-trending" for>{{index+1}}</label>
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div id="search-loading" v-else>
      <i class="loading fas fa-spinner-third fa-spin"></i>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        loop: false,
        // slidesPerView: 1,
        lazy: true,
        // spaceBetween: 10,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange() {}
          //   tap() {}
        }
      }
    };
  },
  filters: {
    dateFilter(date) {
      return moment(date).format("DD/MM/YY");
    },
    roundHalfUp(num) {
      if (num) {
        return num.toFixed(2);
      }
      return num;
    }
  },
  computed: {
    ...mapGetters("stock", ["getTrendingStockList"])
  },
  created() {
    this.$store.state.stock.stockTrendingList.length === 0
      ? this.findStockTrendingList()
      : null;
  },
  methods: {
    ...mapActions("stock", ["findStockTrendingList", "findStockQuote"]),
    async clickList({ security_name }) {
      const hasInfo = await this.findStockQuote(security_name);
      hasInfo
        ? this.$router.push({
            name: "miniapp-stock-quote",
            query: { name: security_name }
          })
        : null;
    }
  }
};
</script>
<style lang="scss" scoped>
#section-trending-stock {
  .trending-data {
    pointer-events: none;
    z-index: 0;
    label {
      z-index: -1;
    }
  }
}
.swiper-slide:last-of-type {
  margin-right: 60px !important;
  @include responsive(tablet) {
    margin-right: 80px !important;
  }
}
#search-loading {
  @extend %container-style;
  text-align: center;
  vertical-align: middle;
  .loading {
    text-align: center;
    font-size: 32px;
    margin: 50px auto auto;
    color: #bababa;
  }
}
</style>